export default {
  login: {
    title: "Connexion",
    subheading: "Vous n’avez pas de compte?",
    buttonText: "Se connecter",
    errorMessages: {
      default: 'Votre adresse courriel ou votre mot de passe ne correspondent pas. Veuillez réessayer.',
      session_expired:
        'Vous avez été inactif pendant un certain temps, votre session a donc expiré. Veuillez vous reconnecter.',
    },
  },
  storeLogin: {
    title: 'Terminez votre commande',
    subheading:
      'Ce n’est pas qu’une simple médaille ou traceur intelligent ; c’est le passeport de votre animal pour rentrer à la maison. Pour profiter pleinement de notre service Home<em>Safe</em><sup>&reg;</sup> de retour d’animaux perdus, nous avons besoin de quelques informations essentielles à votre sujet et à propos de votre animal. Connectez-vous ou créez un compte pour terminer votre commande.',
    buttonTextSignUp: 'Créer un compte',
    buttonTextLogIn: 'Se connecter',
    or: 'OU',
    lowerHeader: 'Ce n’est pas qu’une simple médaille ou traceur intelligent!',
  },
  forgotPassword: {
    title: 'Avez-vous oublié votre mot de passe?',
    info: 'Aucun souci! Nous vous enverrons un courriel avec un lien pour réinitialiser votre mot de passe.',
    buttonText: 'Réinitialiser le mot de passe',
    onSuccess: {
      title: 'On y est presque!',
      info: 'Si vous avez un compte, nous vous enverrons un courriel avec les instructions pour réinitialiser votre mot de passe.',
    },
  },
  resetPassword: {
    title: 'Réinitialiser votre mot de passe',
    subheading: 'On y est presque! Créez un nouveau mot de passe ci-dessous.',
    buttonText: 'Réinitialiser le mot de passe',
    password: {
      title: 'Nouveau mot de passe',
    },
    passwordConfirm: {
      placeholder: 'Retaper le mot de passe',
      title: 'Confirmer le nouveau mot de passe',
    },
    onSuccess: {
      title: 'Opération réussie!',
      infoText: 'Votre mot de passe a été mis à jour.',
      buttonText: 'Retour à la connexion',
    },
    errorMessages: {
      default: 'Un problème est survenu lors de la réinitialisation du mot de passe. {br}Veuillez réessayer.',
      currentPassword: 'Le nouveau mot de passe ne peut pas être identique au mot de passe actuel',
      mismatch: 'Les mots de passe ne correspondent pas',
    },
  },
  completeActivation: {
    loading: {
      title: 'Récupérer votre dossier',
      subheading: 'Vous pourrez créer votre compte en ligne très prochainement',
    },
    title: 'Bonjour {firstName}!',
    subheading: "Votre compte en ligne sécurisé vous permet de…",
    subheadingList: [
      'Inscrire vos animaux',
      'Mettre à jour le statut de vos animaux',
      'Mettre à jour votre adresse et vos coordonnées actuelles',
      'Et bien plus encore!',
    ],
    nonLicensing: {
      title: 'Vous y êtes presque.',
      subheading: 'Créez votre mot de passe et rejoignez un monde conçu pour protéger {petName} et vous apporter la tranquillité d’esprit.',
      petFallback: 'votre animal',
    },
    legalText: {
      prepend: "En vous inscrivant, vous acceptez DocuPet's",
      links: {
        termsOfService: "Conditions d'utilisation",
        conjunction: 'et',
        privacyPolicy: 'Politique de confidentialité',
      },
    },
    buttonText: 'Terminer l’inscription',
    errorMessages: {
        access_code_used: "Vous avez déjà un compte? {br} {action}",
        default: 'There was a problem with your complete sign-up.{br}Please try again.',
        action: {
            access_code_used: 'Cliquez ici pour vous connecter',
        },
    },
    nasn: {
      title: 'Bienvenue dans la famille, {petNames}!',
      subheadingSingular:
        "Créez un mot de passe pour obtenir la médaille gratuite de {petNames} et un accès à l’aide 24/7 pour animaux perdus. Il ne faut qu’un instant pour protéger votre nouveau meilleur ami.",
      subheadingPlural:
        'Créez un mot de passe pour obtenir les médailles gratuites de vos animaux et un accès à l’aide 24/7 pour animaux perdus. Il ne faut qu’un instant pour protéger vos nouveaux meilleurs amis.',
      finishTheDetails: 'Complétez les détails',
      helpGetLostPetsHome: 'Aidez les animaux perdus à rentrer à la maison',
      stayInformed: 'Restez informé',
      buttonText: 'Obtenez votre médaille gratuite',
    },
  },
  fetchMyRecord: {
    title: 'Accéder à mon dossier de licence',
    subheading: 'Si vous avez déjà inscrit un animal auprès de {getCityOrganization}, nous avons probablement votre dossier en main — trouvons-le! Si vous n’avez jamais inscrit votre animal auprès de {getCityOrganization}, {action}.',
    buttonText: {
      primary: 'Rechercher',
    },
    actionText: {
      signUpHere: 'Inscrivez-vous ici'
    },
    nonLicensing: {
      title: 'Protégeons votre animal dès maintenant !',
      subheading: "Votre code d'accès vous donne accès à l'identification complète, à la protection et aux soins.",
    },
    byAccessCode: {
      linkText: 'Voir un exemple',
      descriptionLineOne: 'de "code d’accès"',
      descriptionLineTwo: 'que nous vous avons envoyé par la poste ou par courriel ?',
      title: "J’ai reçu un code d’accès par la poste, par téléphone ou par courriel",
      subheading: "J'ai un code d'accès provenant d'une lettre ou d'un e-mail",
      buttonText: {
        secondary: "J'utiliserai le numéro d'étiquette de mon animal",
      },
      modal: {
        accessCodeExample:{
          title:'Exemple de code d’accès',
        },
        accessCode: {
          title: "Qu’est-ce qu’un code d’accès?",
          content:
            "Lorsque nous recevons les dossiers de {getCityOrganization}, nous envoyons un rappel de renouvellement de licence accompagné d’un code d’accès par la poste ou par courriel (si une adresse courriel a été fournie). Ces codes uniques ne peuvent être utilisés que si les coordonnées fournies correspondent à celles du dossier d’origine. Une fois votre code d’accès utilisé avec succès pour établir la correspondance avec votre compte, vous pourrez créer vos identifiants pour votre compte en ligne, où vous trouverez tous les détails concernant la licence de votre animal.",
        },
      },
      errorMessages: {
        invalid_access_code:
          "Code d'accès ou code postal incorrect. Veuillez vérifier votre courrier électronique ou votre lettre pour confirmer les informations correctes.",
        access_code_used: 'Vous avez déjà un compte? {br} {action}',
        default: 'Un problème est survenu lors de la récupération de votre enregistrement. Veuillez réessayer.',
        action: {
          access_code_used: 'Cliquez ici pour vous connecter',
        },
        onlyAlphaNumericCharacters: 'Le {field} ne peut contenir que des caractères alphanumériques.',
        not_found: 'Oups ! Nous ne trouvons aucun dossier correspondant à ces informations. Veuillez vous assurer que vous avez saisi les données correctement.',
      },
      footerMessage:{
        fallbackText:"Si cela ne fonctionne pas, vous pouvez essayer",
        fallbackLinkText:"d’utiliser le numéro de médaille actuel de votre animal pour accéder à votre dossier",
        learnMoreText: "Pour en savoir plus sur la façon dont nous obtenons les dossiers existants, cliquez",
      }
    },
    byTagNumber: {
      title: "Entrer plutôt le numéro de médaille de mon animal",
      subheading: "J'ai le numéro d'étiquette de mon animal",
      buttonText: {
        secondary: "J'utiliserai mon code d'accès",
      },
      errorMessages: {
        invalid_tag_number:
          "Numéro d'étiquette ou nom de l'animal ou code postal ou numéro de téléphone incorrect. Veuillez vérifier votre courrier électronique ou votre lettre pour confirmer les informations correctes.",
        access_code_used: 'Vous avez déjà un compte? {br} {action}',
        default: 'Un problème est survenu lors de la récupération de votre enregistrement. Veuillez réessayer.',
        action: {
          access_code_used: 'Cliquez ici pour vous connecter',
        },
        not_found: "Nous ne trouvons aucune correspondance exacte pour ces informations dans nos dossiers. Veuillez vous assurer que vous avez bien saisi les données, et essayez d’autres numéros de téléphone au besoin."
      },
      modal: {
        infoTitle: "Quel est le numéro de médaille actuel de mon animal?",
        modalDescription: "Nous disposons généralement d’anciens dossiers de licence contenant les numéros de médaille des animaux. Si votre animal porte une médaille, utilisez ici le numéro qui y figure. Si cette information, ainsi que le nom de votre animal, votre code postal et votre numéro de téléphone, correspondent à l’un de vos dossiers, nous pourrons établir la correspondance! Vous pourrez ensuite créer un compte DocuPet et consulter les informations de licence de votre animal dans votre profil en ligne.",
      },
      footerMessage: {
        fallbackIntro: "Si vous avez reçu un code d’accès de",
        fallbackDescription:
          "notre part, vous pouvez le saisir ici. Ou si vous pensez que {cityOrganization} a une adresse courriel associée à votre ancien dossier de licence, vous pouvez demander un code d’accès",
        learnMoreText: "Pour en savoir plus sur la façon dont nous obtenons les dossiers existants, cliquez",
      },
      support: {
        customerCarePrefix:
          "Si ces options ne fonctionnent pas, veuillez nous excuser pour les inconvénients occasionnés."
      },
    },
  },
  requestAccessCode: {
    title: "Demander un code d'accès",
    subheading:
      "Nous pourrons peut-être vous envoyer un nouveau code d'accès par e-mail. Entrez votre adresse e-mail ci-dessous.",
    buttonText: 'Continuer',
    onSuccess: {
      title: 'Presque fini!',
      infoText:
        "Nous avons envoyé un code d'accès à {email} avec des instructions pour accéder à votre compte. Si l'e-mail n'arrive pas bientôt, veuillez vérifier votre dossier spam",
      buttonText: 'Retourner pour récupérer mon dossier',
    },
    errorMessages: {
      invalid_email:
        'Nous ne pouvons pas trouver cette adresse e-mail dans notre système. Veuillez vérifier que vous entrez la bonne adresse e-mail.',
      access_code_used: 'Vous avez déjà un compte? {action}',
      default: "Un problème est survenu lors de l'envoi d'un e-mail. Veuillez réessayer.",
      action: {
        access_code_used: 'Cliquez ici pour vous identifier',
      },
    },
    footerMessage: {
      errorDescription: "Nous ne trouvons pas cette adresse courriel dans nos dossiers. Cette information ne nous a probablement pas encore été fournie. Veuillez vous assurer que vous avez bien saisi les informations.",
      fallbackIntro: "Vous pouvez",
      fallbackStrong: "aussi essayer d’utiliser le numéro actuel de la médaille de votre animal pour accéder",
      fallbackDescription: "à votre dossier",
      learnMoreText: "Pour en savoir plus sur la façon dont nous obtenons les dossiers existants, cliquez",
      successMessage: "Nous vous avons envoyé un courriel contenant votre code d’accès. Vous pouvez maintenant récupérer votre dossier à l’aide de ce code.",
    },
    validation: {
      emailNotFound: "Nous ne trouvons pas cette adresse courriel dans nos dossiers."
    },
    modal: {
      title: "Comment nous récupérons vos dossiers de licence existants",
      sectionWhyTitle: "Pourquoi il est important d’associer les dossiers existants",
      sectionWhyDescription:
        "{cityOrganization} nous a transmis les dossiers d’enregistrement d’animaux déjà existants afin que nous puissions vous envoyer des rappels de renouvellement et garder vos informations à jour. Il est essentiel de mettre à jour ces dossiers pour éviter les doublons et éviter l'envoi de rappels inutiles.",

      sectionAccessCodeTitle: "À propos des codes d’accès DocuPet",
      sectionAccessCodeDescription:
        "Lorsque nous envoyons des rappels de renouvellement par la poste ou par courriel (si nous avons votre adresse dans nos dossiers), nous incluons un code d’accès. Ce code unique garantit que seules les coordonnées associées au dossier peuvent y donner accès.",

      sectionMatchingTitle: "Associer les données du propriétaire et de l’animal",
      sectionMatchingDescription:
        "Il arrive que des propriétaires ayant déjà enregistré leur animal auprès de {cityOrganization} se rendent sur notre site pour renouveler leur licence sans avoir encore reçu de code d’accès. Dans ces cas, nous pouvons souvent retrouver leur dossier existant grâce à la correspondance de certaines données. Nous vous demanderons notamment le numéro actuel de la médaille de votre animal, son nom, votre code postal et votre numéro de téléphone. Si toutes ces informations concordent, nous pourrons récupérer votre dossier.",

      sectionAccountTitle: "Création d’un compte DocuPet",
      sectionAccountDescription:
        "Une fois votre dossier associé, vous serez redirigé vers la page de création de compte. Après avoir saisi votre adresse courriel et créé un mot de passe, vous pourrez accéder à toutes les informations de licence de votre animal dans votre profil en ligne."
    },
    successButtonText: "Récupérer mon dossier à l’aide du code d’accès",
  },
  // HomeSafe
  HomeSafe: '{HomeSafe}',
  homeSafe: {
    content: [
      'The unique code on this tag serves as an identifier to help get your pet home quickly if they become lost',
      'Proactively send lost pet alerts from your account',
      'Automatically receive an alert if your pet is found',
    ],
  },
  // Info
  onlineAccount: {
    heading: 'Votre compte DocuPet en ligne comprend :',
    content: [
      'Des centaines de modèles de médailles, ou la possibilité de créer votre propre design',
      'L’accès gratuit au service HomeSafe® de retour des animaux perdus, offert 24 h/24 et 7 j/7',
      'Un tableau de bord centralisé pour les informations et les dossiers de votre animal',
    ],
  },
  text: {
    light: {
      WelcomeTo: 'Welcome to',
    },
    bold: {
      DocuPet: 'DocuPet',
    },
  },
  input: {
    email: {
      label: 'Adresse courriel',
      placeholder: 'Saisir l’adresse courriel',
    },
    password: {
      label: 'Mot de passe',
      placeholder: 'Saisir le mot de passe',
      buttonText: {
        show: 'Montrer',
        hide: 'Cacher',
      },
    },
    createPassword: {
        label: 'Créer un mot de passe',
        placeholder: 'Créer un mot de passe',
    },
    newPassword: {
      label: 'Nouveau mot de passe',
      placeholder: 'Créer un nouveau mot de passe',
    },
    passwordConfirm: {
      label: 'Confirmer le nouveau mot de passe',
      placeholder: 'Saisir à nouveau le mot de passe',
    },
    accessCode: {
      label: "Saisir mon code d’accès à 8 ou 9 chiffres",
      placeholder: "Saisir le code d’accès (ex.: FAB12345)",
      errorMessages: 'Le code d’accès est requis.',
      onlyAlphaNumericCharacters: 'Le code d’accès ne peut contenir que des caractères alphanumériques'
    },
    postalCode: {
      label: 'Code postal associé au dossier',
      placeholder: 'Saisir le code postal',
      errorMessages: 'Veuillez saisir votre code postal',
    },
    tagNumber: {
      label: "Numéro de médaille",
      placeholder: 'Saisir le numéro de médaille (ex.: A1B27890)',
      aboveLabel:
        "Le numéro de médaille et deux des trois champs suivants doivent correspondre pour accéder à votre dossier de licence.",
      errorMessages: {
        tag_number_required: "Veuillez entrer le numéro exactement tel qu’il apparaît sur la médaille.",
      },
    },
    petName: {
      label: "Nom de l’animal",
      placeholder: "Saisir le nom de l’animal",
      errorMessages: 'Veuillez saisir le nom de votre animal',
    },
    phoneNumber: {
      label: 'Numéro de téléphone associé au dossier',
      placeholder: 'Veuillez saisir votre numéro de téléphone',
      customErrorMessage: 'Veuillez saisir votre numéro de téléphone à dix chiffres',
    },
  },
  checkbox: {
    eula: "Je suis d'accord",
    petalert: 'Je souhaite recevoir des alertes concernant les animaux perdus près de mon domicile.',
    shelter: 'Je souhaite partager mon profil avec le Réseau national des refuges pour animaux afin qu’ils puissent m’aider à retrouver mes animaux s’ils se perdent.',
  },
  link: {
    accessCode: {
      dontHave: "Vous n’avez pas de code d’accès?",
    },
    signUp: "Créer un compte",
    forgotPassword: 'Vous avez oublié votre mot de passe?',
    login: {
      return: 'Retour à la connexion',
    },
    fetchMyRecord: {
      return: 'Retourner pour récupérer mon dossier',
    },
  },
  validations: {
    messages: {
      required: 'req',
    },
  },
  footer: {
    copyright: 'DocuPet Corp. Tous droits réservés.',
    links: {
      about: 'About DocuPet',
      tos: "Conditions d'utilisation",
      privacy: 'Politique de confidentialité',
    },
  },
  meta: {
    title: {
      LogIn: "S'identifier",
      ResetPassword: 'Réinitialisez votre mot de passe',
      ForgotPassword: 'Mot de passe oublié?',
      CompleteSignup: 'Complétez votre inscription',
      RequestAccessCode: "Demander un code d'accès",
      FetchMyRecordByPetTag: 'Récupère mon dossier',
      FetchMyRecordByAccessCode: 'Récupère mon dossier',
      FetchMyRecordByTagNumber: 'Fetch my record',
      StoreLogIn: 'Store Log In',
    },
  },
  CUSTOMER_CARE_PHONE: '1-877-239-6072',
};
